import React, { FunctionComponent, useEffect } from "react";
import { Slider, Rail, Handles, Tracks, Ticks } from "react-compound-slider";
import { SliderRail, Handle, Track, Tick } from "./components";

const sliderStyle = {
  position: "relative" as "relative",
  width: "100%",
  touchAction: "none",
};
type ownProps = {
  domain: Array<number>;
  value: number;
  onValueChange: (e: Array<number>) => void;
};

const CompoundSlider: FunctionComponent<ownProps> = (props: ownProps) => {
  const { domain, value, onValueChange } = props;

  const [values, setValues] = React.useState([value]);

  const onChange = (e: ReadonlyArray<number>) => {
    onValueChange(e as Array<number>);
  };

  useEffect(() => {
    setValues([value]);
  }, [value]);

  return (
    <div style={{ width: "100%" }}>
      <Slider
        mode={1}
        step={1}
        domain={domain}
        rootStyle={sliderStyle}
        onChange={onChange}
        values={values}
        key={Math.random().toFixed(3).toString()}
      >
        <Rail>
          {({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}
        </Rail>
        <Handles>
          {({ handles, activeHandleID, getHandleProps }) => (
            <div className="slider-handles">
              {handles.map((handle) => (
                <Handle
                  key={handle.id}
                  handle={handle}
                  domain={domain}
                  isActive={handle.id === activeHandleID}
                  getHandleProps={getHandleProps}
                />
              ))}
            </div>
          )}
        </Handles>
        <Tracks right={false}>
          {({ tracks, getTrackProps }) => (
            <div className="slider-tracks">
              {tracks.map(({ id, source, target }) => (
                <Track
                  key={id}
                  source={source}
                  target={target}
                  getTrackProps={getTrackProps}
                />
              ))}
            </div>
          )}
        </Tracks>
        <div className="flex relative justify-between top-2 text-sm">
          <p className="flex flex-col">
            <span
              className="rotate-90"
              style={{ lineHeight: "5px", fontSize: "1rem" }}
            >
              -
            </span>
          </p>
          <p className="flex flex-col">
            <span
              className="rotate-90"
              style={{ lineHeight: "5px", fontSize: "1rem" }}
            >
              -
            </span>
          </p>
          <p className="flex flex-col">
            <span
              className="rotate-90"
              style={{ lineHeight: "5px", fontSize: "1rem" }}
            >
              -
            </span>
          </p>
        </div>
        <div className="flex relative justify-between top-2 text-sm">
          <span className="text-sm">{domain[0]}%</span>
          <span className="text-sm">
            {Math.floor((domain[0] + domain[1]) / 2)}%
          </span>
          <span className="text-sm">{domain[1]}%</span>
        </div>
      </Slider>
    </div>
  );
};

export { CompoundSlider, CompoundSlider as default };
